import React from 'react';
import './Header.scss';
import { useTranslation } from 'react-i18next';

const APP_STORE = 'https://apps.apple.com/us/app/summail-ai/id6743159952';
const SCHEME   = 'summailai://';

const open = () => {
  
  const now = Date.now();
  // 1. 尝试 Scheme
  window.location.href = SCHEME;

  // 2. 500ms 后若页面还在（说明 app 没被拉起）跳 App Store
  setTimeout(() => {
    // iOS 15+ Safari 会在成功唤起 App 时自动挂起网页，以下逻辑执行不到
    if (Date.now() - now < 1500) {
      window.location.href = APP_STORE;
    }
  }, 1000);
};

const Header: React.FC = () => {

const { t } = useTranslation();
return (
  <header className="noteHeader">
    <div className='container'>
      <div className="logo">
        <div className='logoImg'></div>
        <span>SumMail AI</span>
      </div>
      <button onClick={open} className="btn">{t('SumMailAI_1_0_0_web_open_app')}</button>
    </div>
  </header>
);
}

export default Header;

